import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    editNombreCentreRequest: ['response'],
    editNombreCentreSuccess: ['response', 'loading'],
    editNombreCentreFailure: ['error'],
})

export const editNombreCentreTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    success: null,
    response: null,
    error: null,
})

/* ------------- Reducers ------------- */

const editNombreCentreRequest = state => state.merge({ success: null })

const editNombreCentreSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const editNombreCentreFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.EDIT_NOMBRE_CENTRE_REQUEST]: editNombreCentreRequest,
    [Types.EDIT_NOMBRE_CENTRE_SUCCESS]: editNombreCentreSuccess,
    [Types.EDIT_NOMBRE_CENTRE_FAILURE]: editNombreCentreFailure,
})
